import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../translation/translation';
import { Filters } from '../../../../constants/filter/filters';

function NoneGiven(props) {
    const filters = props.filters;
    const hasRegion = filters ? !!filters.region : '';
    const hasPostcode = filters ? filters[Filters.POSTCODE] !== '' : false;
    const showPostcode = filters ? (hasPostcode || props.postcodeExistsButNeedsToBeLoaded) : false;

    return (
        <span className="statusbar__missing-status">
            <span className="statusbar__add-information" onClick={props.onClick}>
                <Translation translationKey="catalog-missing-status-no-data-clickable" />
            </span>

            {showPostcode
                ? <span
                    className="statusbar__current-status-postcode statusbar__current-status-value"
                    style={{ border: '1px solid #333', color: '#333' }}
                    onClick={() => props.onChange(["postcode"])}
                >
                    {hasRegion && filters && filters.region}
                    {hasRegion && hasPostcode && ', '}
                    {hasPostcode && filters && filters[Filters.POSTCODE]}
                    <Translation
                        translationKey="catalog-current-status-edit"
                        className="statusbar__current-status-value-edit"
                        style={{ color: '#333' }}
                    />
                </span>
                : (<span>
                    <Translation
                        translationKey="catalog-missing-status-missing-postcode"
                        className="statusbar__add-information"
                        style={{ margin: '0 20px' }}
                        onClick={() => props.onChange(["postcode"])}
                    />
                </span>)}
        </span>
    );
}

NoneGiven.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default NoneGiven;
